import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ResponsibleEntityListComponent } from '../../../Responsible-Entity/Responsible-Entity-List/responsibleEntityList.component';
import { PanelChevronComponent } from '../../../UI-Lib/Weissman-Panel/panel.chevron.component';
import { EntityService } from '../../entity.service';
import { AceLoaderComponent } from '../../../UI-Lib/ACE/Loader/loader.component';

@Component({
    selector: 'responsible-entity-panel',
    templateUrl: './responsibleEntityPanel.component.html',
    imports: [AceLoaderComponent, CommonModule, PanelChevronComponent, ResponsibleEntityListComponent],
})
export class ResponsibleEntityPanelComponent {
    constructor(private readonly _entityService: EntityService) {}

    @Input() companyId: number;
    @Input() siteId?: number;
    @Input() parcelId?: number;
    @Input() enableAllocations: boolean;

    loading: boolean = true;
    showBody: boolean = false;
    isMaximized: boolean = false;

    expandOrCollapse(): void {
        if (this.isMaximized) {
            return;
        }

        this.showBody = !this.showBody;
    }

    onLoadingChanged(loading: any) {
        loading = loading as boolean;
        this.loading = loading;
    }

    maximize(event): void {
        this.isMaximized = true;
        this.showBody = true;
        this._broadcastMaximize();
        event.stopPropagation();
    }

    unmaximize(event): void {
        this.isMaximized = false;
        this._broadcastMaximize();
        event.stopPropagation();
    }

    private _broadcastMaximize(): void {
        this._entityService.setMaximizeChange({
            panelName: 'responsibleEntityPanel',
            maximized: this.isMaximized,
        });
    }
}
